document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('ss-radio-input')) return;
  var widget = e.target.closest('.subscribe-save-widget');
  widget.querySelector('.ss-hidden-selling-plan').value = e.target.value;
  widget.querySelectorAll('.ss-option').forEach(function (o) {
    o.classList.remove('is-selected');
  });
  e.target.closest('.ss-option').classList.add('is-selected');
});

document.querySelectorAll('.faq-accordion details').forEach(function (details) {
  var wasOpen = details.hasAttribute('open');
  var summary = details.querySelector('summary');

  details.setAttribute('open', '');
  if (wasOpen) details.classList.add('is-open');

  summary.addEventListener('click', function (e) {
    e.preventDefault();
    details.classList.toggle('is-open');
  });
});

document.querySelectorAll('.product__accordion details').forEach(function (details) {
  var summary = details.querySelector('summary');
  details.setAttribute('open', '');
  summary.addEventListener('click', function (e) {
    e.preventDefault();
    details.classList.toggle('is-open');
  });
});

(function() {
  var carousel = document.querySelector('.facts-carousel');
  var win = carousel && carousel.querySelector('.facts-window');
  var track = document.getElementById('factsTrack');
  var dots = document.querySelectorAll('.facts-dot');
  var prev = document.getElementById('factsPrev');
  var next = document.getElementById('factsNext');
  if (!track || !win) return;

  var current = 0;
  var slides = track.querySelectorAll('.facts-slide');
  var total = slides.length;
  var startX = 0;
  var currentX = 0;
  var isDragging = false;
  var dragThreshold = 50;

  function getSlideWidth() { return win.offsetWidth; }

  function goTo(index, animate) {
    current = (index + total) % total;
    track.style.transition = animate === false ? 'none' : 'transform 0.5s ease';
    track.style.transform = 'translateX(-' + (current * getSlideWidth()) + 'px)';
    dots.forEach(function(d) { d.classList.remove('is-active'); });
    if (dots[current]) dots[current].classList.add('is-active');
  }

  function setSlideSizes() {
    var w = getSlideWidth();
    slides.forEach(function(slide) {
      slide.style.width = w + 'px';
      slide.style.flexShrink = '0';
    });
    track.style.transition = 'none';
    track.style.transform = 'translateX(-' + (current * w) + 'px)';
    setTimeout(function() { track.style.transition = 'transform 0.5s ease'; }, 50);
  }

  // Mouse drag
  win.addEventListener('mousedown', function(e) {
    isDragging = true;
    startX = e.clientX;
    currentX = 0;
    track.style.transition = 'none';
    win.style.cursor = 'grabbing';
  });

  window.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    currentX = e.clientX - startX;
    var base = -(current * getSlideWidth());
    track.style.transform = 'translateX(' + (base + currentX) + 'px)';
  });

  window.addEventListener('mouseup', function() {
    if (!isDragging) return;
    isDragging = false;
    win.style.cursor = 'grab';
    if (currentX < -dragThreshold) goTo(current + 1);
    else if (currentX > dragThreshold) goTo(current - 1);
    else goTo(current);
  });

  // Touch drag
  win.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    currentX = 0;
    track.style.transition = 'none';
  }, { passive: true });

  win.addEventListener('touchmove', function(e) {
    currentX = e.touches[0].clientX - startX;
    var base = -(current * getSlideWidth());
    track.style.transform = 'translateX(' + (base + currentX) + 'px)';
  }, { passive: true });

  win.addEventListener('touchend', function() {
    if (currentX < -dragThreshold) goTo(current + 1);
    else if (currentX > dragThreshold) goTo(current - 1);
    else goTo(current);
  });

  // Prevent image drag interfering
  track.querySelectorAll('img').forEach(function(img) {
    img.addEventListener('dragstart', function(e) { e.preventDefault(); });
  });

  prev.addEventListener('click', function() { goTo(current - 1); });
  next.addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.index)); });
  });

  window.addEventListener('resize', setSlideSizes);
  setSlideSizes();
  win.style.cursor = 'grab';
})();

document.querySelectorAll('img').forEach(function(img) {
  img.addEventListener('contextmenu', function(e) { e.preventDefault(); });
  img.setAttribute('draggable', 'false');
});